import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatListModule } from '@angular/material/list';

@Component({
  selector: 'app-lds-ellipsis',
  styleUrl: './lds-ellipsis.component.scss',
  templateUrl: './lds-ellipsis.component.html',
  standalone: true,
  imports: [CommonModule, MatListModule],
})
export class LdsEllipsisComponent {
  @Input() public isLoading!: boolean;
  constructor() {}
}
